import { FETCH_TOKEN, FETCH_TOKEN_ERROR, FETCH_TOKEN_START, FETCH_TOKEN_END } from '../actions/types';

const initialState = {
  isLoading: null,
  user: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOKEN_START:
      return { ...initialState, isLoading: true };
    case FETCH_TOKEN_END:
      return { ...state, isLoading: false };
    case FETCH_TOKEN:
      return { ...state, user: action.payload };
    case FETCH_TOKEN_ERROR:
      return { error: action.payload, user: false };
    default:
      return state;
  }
}
